module.exports = __webpack_public_path__ + "static/fipclilacrainmain-541b6414bb871eb6e7013bf31475eed9.jpeg";